const upsert = (selector, create) => {
  let element = document.head.querySelector(selector)

  if (!element) {
    element = create()
    document.head.appendChild(element)
  }

  return element
}

const setMeta = (name, content) => {
  const element = upsert(`meta[name="${name}"]`, () => {
    const meta = document.createElement('meta')
    meta.setAttribute('name', name)
    return meta
  })

  element.setAttribute('content', content)
}

const setLink = (rel, href) => {
  const element = upsert(`link[rel="${rel}"]`, () => {
    const link = document.createElement('link')
    link.setAttribute('rel', rel)
    return link
  })

  element.setAttribute('href', href)
}

const absolute = value => new URL(value, window.location.origin).href

const manifestHref = theme => {
  const origin = window.location.origin

  const manifest = {
    short_name: 'Chamada Escolar',
    name: theme.title,
    description: theme.description,
    icons: theme.favicon ? [{ src: absolute(theme.favicon), sizes: 'any' }] : [],
    start_url: `${origin}/`,
    scope: `${origin}/`,
    display: 'standalone',
    theme_color: theme.palette.primary.main,
    background_color: '#CFCFCF',
  }

  return `data:application/manifest+json,${encodeURIComponent(
    JSON.stringify(manifest)
  )}`
}

const applyDocumentHead = theme => {
  try {
    document.title = theme.title
    setMeta('description', theme.description)
    setMeta('theme-color', theme.palette.primary.main)
    if (theme.favicon) setLink('icon', theme.favicon)
    setLink('manifest', manifestHref(theme))
    document.body.style.backgroundColor = theme.palette.background.default
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[documentHead]', error)
  }
}

export default applyDocumentHead
